import { Stack, useTheme } from '@mui/material'
import { InstitutionLogo } from '../institution-logo/InstitutionLogo'
import { TextBody } from '@front/components/data-display/typography/Typography'
import { ChevronRightOutlined } from '@mui/icons-material'

type CardProps = {
  slug: string
  logoUri?: string
  name: string
}

export default function InstitutionCard({ slug, logoUri, name }: CardProps) {
  const theme = useTheme()

  return (
    <a
      href={`/${slug}`}
      rel="noopener noreferrer"
      target="_blank"
      style={{
        color: theme.palette.text.primary,
        width: '100%',
        textDecoration: 'none',
      }}
    >
      <Stack
        sx={{
          width: '100%',
          padding: 2,
          gap: 2,
          flexDirection: 'row',
          alignItems: 'center',
          border: 'solid 1px',
          borderColor: theme.palette.border['brand-subtle'],
          boxShadow:
            '0 2px 4px 0 rgba(25, 23, 21, 0.03), 0 8px 8px 0 rgba(25, 23, 21, 0.02)',
          borderRadius: 2,
        }}
      >
        <InstitutionLogo url={logoUri} alt={`institution-logo-card-${slug}`} />
        <TextBody sx={{ flex: 1 }}>{name}</TextBody>
        <ChevronRightOutlined
          sx={{ width: 24, height: 24, color: theme.palette.text.secondary }}
        />
      </Stack>
    </a>
  )
}
